import React, { useState, Fragment } from "react";
import { useNavigate } from "react-router-dom";
import { useForgotPasswordCheck } from "Api/Password";
import ClooserLogo from "../../../src/assets/utils/images/logo_Clooser_blue_orange.png";
import "../../../src/assets/pages/_loginBoxed.scss";

const ForgotPassword = () => {
  const [vUserName, setVUserName] = useState("");
  const [vSecondUserName, setVSecondUserName] = useState("");
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [isEmailError, setIsEmailError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { trigger: forgotPasswordCheck } = useForgotPasswordCheck();

  const handleSubmit = (e) => {
    e.preventDefault();
    setHasSubmitted(true);

    const trimmedUsername = vUserName.trim();
    const trimmedSecondUsername = vSecondUserName.trim();

    if (!trimmedUsername && !isEmailError) {
      setError("Vul je gebruikersnaam of e-mailadres in.");
      setMessage(null);
      return;
    }

    if (isEmailError && !trimmedSecondUsername) {
      setError("Vul je gebruikersnaam in om verder te gaan.");
      setMessage(null);
      return;
    }

    let payload = {
      userNameEmail: trimmedUsername,
    };

    if (isEmailError && trimmedSecondUsername) {
      payload.vUserName = trimmedSecondUsername;
    }

    setIsLoading(true);

    forgotPasswordCheck({
      data: payload,
    })
      .then((response) => {
        const { count } = response;

        if (typeof count === "number" && count > 0) {
          setError(
            "Dit e-mailadres is gekoppeld aan meerdere gebruikers. Voer uw gebruikersnaam in om door te gaan met het verzenden van de e-mail."
          );
          setMessage(null);
          setIsEmailError(true);
          return;
        }

        setMessage(
          <>
            Als deze e-mail aan een account is gekoppeld, wordt er een resetlink naar uw e-mailadres gestuurd.
            Geen e-mail ontvangen? Neem dan contact op met{" "}
            <a
              href="https://www.clooser.nl/contact"
              target="_blank"
              rel="noopener noreferrer"
             
            >
              support
            </a>{" "}
            of het schoolbestuur.
          </>
        );
        setError(null);
      })
      .catch(() => {
        setError("Er is een fout opgetreden. Probeer het opnieuw.");
        setMessage(null);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <Fragment>
      <div className="forgot-password-page">

        <div className="backdrop" aria-hidden="true">
          <div className="circle circle-blue"></div>
          <div className="circle circle-orange"></div>
          <div className="circle circle-outline"></div>
        </div>

        <header className="page-header">
          <a className="quiet-link back-link" href="https://clooser.nl/">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 5-7 7 7 7M5 12h14" /></svg>
            Naar clooser.nl
          </a>
          <nav className="header-actions" aria-label="Ondersteuning">
            <a className="help-link status-link" href="https://www.clooserstatus.nl/" target="_blank" rel="noopener noreferrer">
              Systeemstatus
              <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17 17 7M7 7h10v10" /></svg>
            </a>
            <a className="help-link" href="https://www.clooser.nl/vervangers/contact/" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9" /><path d="M9.5 9a2.5 2.5 0 0 1 5 .5c0 2-2.5 2-2.5 4M12 17h.01" /></svg>
              Hulp nodig?
            </a>
          </nav>
        </header>

        <main className="login-form-page">
          <div className="login-wrap">
            <a className="brand" href="https://clooser.nl/" aria-label="Clooser.nl, naar de website">
              <img src={ClooserLogo} alt="Clooser.nl" width="2172" height="724" />
            </a>

            <section className="login-card" aria-labelledby="form-title">
              <div className="card-heading">
                <p className="eyebrow">CLOOSER</p>
                <h1 id="form-title" tabIndex={-1}>Wachtwoord vergeten?</h1>
                {!hasSubmitted && (
                  <p id="form-intro">Geen zorgen. Vul uw gebruikersnaam of e-mailadres in om een herstellink aan te vragen.</p>
                )}
              </div>

              {message ? (
                <>
                  <div className="form-notice" id="recovery-notice" role="status">
                    {message}
                  </div>
                  <button
                    className="return-button"
                    type="button"
                    onClick={() => navigate("/login")}
                  >
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 5-7 7 7 7M5 12h14" /></svg>
                    Terug naar inloggen
                  </button>
                </>
              ) : (
                <form id="recovery-form" noValidate onSubmit={handleSubmit}>
                  <div className="field">
                    <label htmlFor="recovery-identifier">Gebruikersnaam of e-mailadres</label>
                    <input
                      id="recovery-identifier"
                      name="identifier"
                      type="text"
                      autoComplete="username"
                      autoCapitalize="none"
                      spellCheck="false"
                      placeholder="Uw gebruikersnaam of e-mailadres"
                      aria-describedby="identifier-error"
                      aria-invalid={!!(error && !isEmailError)}
                      value={vUserName}
                      onChange={(e) => setVUserName(e.target.value)}
                      readOnly={isEmailError}
                    />
                  </div>

                  {isEmailError && (
                    <div className="field">
                      <label htmlFor="recovery-username">Gebruikersnaam</label>
                      <input
                        id="recovery-username"
                        name="username"
                        type="text"
                        autoComplete="username"
                        autoCapitalize="none"
                        spellCheck="false"
                        placeholder="Vul uw gebruikersnaam in"
                        aria-describedby="username-error"
                        aria-invalid={!!error}
                        value={vSecondUserName}
                        onChange={(e) => setVSecondUserName(e.target.value)}
                      />
                    </div>
                  )}

                  <button className="primary-button recovery-submit" type="submit" disabled={isLoading}>
                    <span>{isLoading ? "Versturen..." : "Verstuur herstellink"}</span>
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15m-6-6 6 6-6 6" /></svg>
                  </button>

                  {error ? (
                    <div className="form-notice notice-error" id="recovery-notice" role="status">
                      {error}
                    </div>
                  ) : null}

                  <div className="recovery-help">
                    <strong>Geen e-mail ontvangen?</strong>
                    <p>Controleer uw ongewenste e-mail. Neem zo nodig contact op met de coördinator van uw bestuur.</p>
                  </div>

                  <a className="return-button" href="/login">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 5-7 7 7 7M5 12h14" /></svg>
                    Terug naar inloggen
                  </a>
                </form>
              )}

              <div className="card-footers">
                <span>Komt u er niet uit?</span>
                <a href="https://www.clooser.nl/vervangers/contact/" target="_blank" rel="noopener noreferrer">
                  Wij helpen u graag
                  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 17 17 7M7 7h10v10" /></svg>
                </a>
              </div>
            </section>
          </div>
        </main>
      </div>
    </Fragment>
  );
};

export default ForgotPassword;
